export const STATUS: {[key:string] : string } = {
    EDITING: 'Editing',
    REPLYING: 'Replying',   
  }